import { render, staticRenderFns } from "./EmailTemplatePage.vue?vue&type=template&id=6f39a392&scoped=true&"
import script from "./EmailTemplatePage.vue?vue&type=script&lang=js&"
export * from "./EmailTemplatePage.vue?vue&type=script&lang=js&"
import style0 from "./EmailTemplatePage.vue?vue&type=style&index=0&id=6f39a392&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f39a392",
  null
  
)

export default component.exports